@if (loginView === E_LOGINVIEW.ENTER_REGISTRATIONCODE) {
  <p>
    {{'ENTER_CODE_MSG' | translate}}
  </p>
  <div class="formgrid grid">
    <!--<div class="field col-12">
      <span>{{'ACCOUNT' | translate}}:&nbsp;{{playerProfileService.playerAuthenticationService.registrationUsername}}</span>
    </div>-->
    <div class="field col-12">
      <app-formgrid-label label="VERIFICATION_CODE" [mandatory]="true"/>
      <p-inputOtp [(ngModel)]="mailVerificationCode" [length]="6"
                  (keyup)="mailVerificationCode = mailVerificationCode.toUpperCase()"/>
    </div>

    <div class="field col-12">
      <app-formgrid-label label="NEW_PASSWORD" [mandatory]="true"/>
      <p-password [(ngModel)]="forgotPassword1"
                  [placeholder]="'PASSWORD_PLACEHOLDER_MIN_X' | translate: {value: passwordMinLength}"
                  styleClass="p-password-input p-password p-component p-inputwrapper p-input-icon-right"
                  class="grid-comp-full-width" [feedback]="false" [toggleMask]="true"/>
    </div>
    <div class="field col-12">
      <app-formgrid-label label="PASSWORD_RETYPE" [mandatory]="true"/>
      <p-password [(ngModel)]="forgotPassword2"
                  (keydown.enter)="onChangePasswordClicked()"
                  styleClass="p-password-input p-password p-component p-inputwrapper p-input-icon-right"
                  class="grid-comp-full-width" [feedback]="false" [toggleMask]="true"/>
    </div>
  </div>

  @if (errorMsgChangePassword) {
    <div class="pb-3 red">
      <p-message severity="error" [text]="errorMsgChangePassword"/>
    </div>
  }
  <p-button [label]="'CHANGE_PASSWORD' | translate"
            icon="pi pi-check" styleClass="grid-comp-full-width"
            [loading]="isSaving"
            [disabled]="isSaving || !mailVerificationCode || !forgotPassword1 || !forgotPassword2 || forgotPassword1 !== forgotPassword2"
            (onClick)="onChangePasswordClicked()"/>

  <p-divider></p-divider>
  <div class="text-sm">
    <p-button [label]="'BACK_TO_LOGIN' | translate" styleClass="p-button-text" (click)="backToLogin()"/>
  </div>

} @else {
  <div class="formgrid grid">
    <div class="field col-12">
      <app-formgrid-label label="MAIL_ADDRESS_OR_PLAYER_NUMBER"/> <!-- ENTER_MAIL_ADDRESS_OR_PLAYER_NUMBER -->
      <p-input-group>
        <input #inputUsername
               pInputText
               type="text"
               inputmode="email"
               class="p-inputtext w-full"
               [(ngModel)]="username"
               [disabled]="loginView === E_LOGINVIEW.LOGIN_PASSWORD || isSaving"
               [placeholder]="'MAIL_ADDRESS_OR_PLAYER_NUMBER' | translate"
               (keydown.enter)="onUsernameNextClicked()"
               (change)="trimUsername()">

        @if (loginView === E_LOGINVIEW.LOGIN_PASSWORD) {
          <p-button icon="pi pi-pencil" severity="secondary" (onClick)="changeUsername()"/>
        }
      </p-input-group>

      <!--<input #inputUsername
             pInputText
             type="text"
             inputmode="email"
             class="p-inputtext w-full"
             [(ngModel)]="username"
             [disabled]="loginView === E_LOGINVIEW.LOGIN_PASSWORD || isSaving"
             [placeholder]="'MAIL_ADDRESS_OR_PLAYER_NUMBER' | translate"
             (keydown.enter)="onUsernameNextClicked()"
             (change)="trimUsername()">-->
    </div>

    @if (loginView === E_LOGINVIEW.LOGIN_PASSWORD && !usernameNotPlayerProfile) {
      <div class="field col-12">
        <app-formgrid-label label="PASSWORD"/>
        <p-password #inputPassword
                    id="password"
                    [(ngModel)]="password"
                    [disabled]="isSaving"
                    [placeholder]="'PASSWORD' | translate"
                    (keydown.enter)="onOkClicked()"
                    styleClass="p-password-input p-password p-component p-inputwrapper p-input-icon-right"
                    class="grid-comp-full-width" [feedback]="false" [toggleMask]="true"/>
      </div>
    }
  </div>
  @if (response?.errorMsg) {
    <div class="pb-3 red">
      <p-message severity="error" [text]="response.errorMsg | translate: {value: response.attemptsLeft}"/>
    </div>
  }

  @if (loginView === E_LOGINVIEW.LOGIN) {
    <p-button [label]="'CONTINUE' | translate"
              icon="pi pi-angle-right" styleClass="grid-comp-full-width"
              [loading]="isSaving"
              [disabled]="isSaving || !username"
              (onClick)="onUsernameNextClicked()"/>
  } @else if (loginView === E_LOGINVIEW.LOGIN_PASSWORD) {
    @if (usernameNotPlayerProfile) {
      <app-info-text text="LOGIN_IS_PART_OF_3K_LOGIN" color="accent"/>
      <div class="pt-3">
        <p-button [label]="('THREEK_BACKEND_NAME' | translate) + ' - ' + ('LOGIN' | translate)"
                  icon="pi pi-sign-in" styleClass="grid-comp-full-width"
                  severity="info"
                  (onClick)="goto3KLogin()"/>
      </div>
    } @else {
      <div>
        <p-button [label]="'LOGIN' | translate"
                  icon="pi pi-check" styleClass="grid-comp-full-width"
                  [loading]="isSaving"
                  [disabled]="isSaving || !password || !username"
                  (onClick)="onOkClicked()"/>
      </div>
    }
  }
  <!--@if (usernameNotPlayerProfile || loginView === E_LOGINVIEW.LOGIN_PASSWORD) {
    <div class="pt-3">
      <p-button [label]="'PLAYER_PROFILE_CHANGE_USERNAME' | translate"
                icon="pi pi-user-edit" styleClass="grid-comp-full-width"
                severity="secondary"
                (onClick)="changeUsername()"/>
    </div>
  }-->

  @if (loginView === E_LOGINVIEW.LOGIN_PASSWORD && !usernameNotPlayerProfile) {
    <p-divider/>
    <div class="text-sm">
      <p-button [label]="'FORGOT_PASSWORD' | translate"
                styleClass="p-button-text"
                [disabled]="!username"
                [loading]="isResettingPassword"
                (click)="resetPassword()"/>
    </div>
  }

  <!-- Noch keinen Zugang? Account erstellen -->
  <!-- @if (showRegistration) { -->

  @if (loginView === E_LOGINVIEW.LOGIN) {
    <p-divider class="pt-3"/>
    <div class="flex justify-content-center pt-2">
      <div class="flex align-items-center gap-2">
        <span class="material-symbols-outlined text-xl">frame_person</span>
        <span class="font-italic">{{'NO_ACCOUNT_YET_Q' | translate}}</span>
      </div>
    </div>
    <div class="flex justify-content-center pt-2">
      <p-button [label]="'GET_YOUR_PLAYER_PROFILE_ACCOUNT' | translate"
                styleClass="p-button-text" size="large"
                (onClick)="createAccount()"/>
    </div>
  }
}
